/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SaasEnvironmentType } from './saasEnvironmentType';


export interface SaasEnvironment { 
    cspUrl?: string;
    servicePlaneEnvironment?: SaasEnvironmentType;
    vmcUrl?: string;
}
export namespace SaasEnvironment {
}


